"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsForceShootSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../../constants");
/**
 * This is only a slice of SF data. If you need more, add more
 */
exports.JsForceShootSchema = joi_1.default.object({
    Id: joi_1.default.string().required(),
    Name: joi_1.default.string().required(),
    Location__c: joi_1.default.string().required(),
    Shoot_UUID__c: joi_1.default.string().uuid().allow(null),
    External_Reference__c: joi_1.default.string().allow(null),
    Link_to_submission__c: joi_1.default.string().allow(null),
    Link_to_customer_submission__c: joi_1.default.string().allow(null),
    Status__c: joi_1.default.string().required(),
    Rescheduling__c: joi_1.default.string().allow(null),
    Rescheduling_Detail__c: joi_1.default.string().allow(null),
    End_Date_and_Time__c: joi_1.default.string().required(),
    Start_Date_and_Time__c: joi_1.default.string().required(),
    Customer__c: joi_1.default.string().required(),
    Photographer__c: joi_1.default.string().allow(null),
    Shooting_Price__c: joi_1.default.number().allow(null),
    Source__c: joi_1.default.string().allow(null),
    Contact_Email__c: joi_1.default.string()
        .email({ tlds: { allow: !constants_1.isBrowser } })
        .allow(null),
    Location_UUID__c: joi_1.default.string().uuid().required(),
    Link_to_attachment__c: joi_1.default.string().allow(null),
    Lost_Reason__c: joi_1.default.string().allow(null),
    Shooting_Information__c: joi_1.default.string().allow(null, ''),
    Lost_Time__c: joi_1.default.string().allow(null),
    Cancelled_by__c: joi_1.default.string().allow(null),
    Lost_Text__c: joi_1.default.string().allow(null),
    Shooting_Specification__c: joi_1.default.string().allow(null),
    Category__c: joi_1.default.string().allow(null),
    Latitude__c: joi_1.default.string().allow(null),
    Longitude__c: joi_1.default.string().allow(null),
    Location_Consent__c: joi_1.default.boolean().required(),
    Product__c: joi_1.default.string().allow(null),
    Nr_of_Photos__c: joi_1.default.number().allow(null),
    Booked_by__c: joi_1.default.string().allow(null),
    BillingAddressShoot__c: joi_1.default.string().allow(null)
})
    .unknown(true)
    .meta({ className: 'JsForceShoot' });
//# sourceMappingURL=JsForceShootSchema.js.map